import {useMatchMedia} from '@pexip/hooks';

import {MD_DOWN} from '../../constants/mediaQueries';

export const useMdDown = () => useMatchMedia(MD_DOWN);
